(function(){
    var root = document.querySelector('[data-ga-lp]');
    if (!root) return;
    function track(name, detail){ try { if (window.dataLayer) window.dataLayer.push(Object.assign({event: name}, detail || {})); } catch(e){} }
    root.querySelectorAll('[data-ga-scroll]').forEach(function(el){
      el.addEventListener('click', function(e){
        var href = el.getAttribute('href') || '#ga-bundles';
        var target = document.querySelector(href);
        if (target){ e.preventDefault(); target.scrollIntoView({behavior:'smooth', block:'start'}); }
        track('ga_choose_bundle', { source: el.getAttribute('data-ga-track') || '' });
      });
    });
    function openCart(){
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (typeof window.UDCartRefresh === 'function'){ window.UDCartRefresh(); }
      else { var o = document.querySelector('[data-ud-cart-open]'); if (o){ o.click(); } else { window.location.href = '/cart'; } }
    }
    root.querySelectorAll('[data-ga-atc]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        var name = btn.getAttribute('data-bundle') || '';
        if (!vid){ window.alert('This bundle is not available to add yet.'); return; }
        var orig = btn.innerHTML;
        btn.disabled = true; btn.textContent = 'Adding...';
        function finish(){ btn.disabled = false; btn.innerHTML = orig; }
        fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: vid, quantity: qty }) })
          .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, data:d}; }); })
          .then(function(res){
            finish();
            if (!res.ok){ console.error('GA add failed', res.data); window.alert((res.data && res.data.description) || 'Sorry, that could not be added to your basket.'); return; }
            track('add_to_cart_landing', { bundle: name, quantity: qty });
            openCart();
          })
          .catch(function(err){ finish(); console.error('GA add error', err); window.alert('Sorry, something went wrong adding to your basket.'); });
      });
    });
    root.querySelectorAll('[data-ga-ba]').forEach(function(ba){
      var before = ba.querySelector('[data-ga-ba-before]');
      var handle = ba.querySelector('[data-ga-ba-handle]');
      var range  = ba.querySelector('[data-ga-ba-range]');
      function setPos(p){ p = Math.max(0, Math.min(100, p)); if (before) before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)'; if (handle) handle.style.left = p + '%'; }
      if (range){ range.addEventListener('input', function(){ setPos(parseFloat(range.value)); }); }
      setPos(50);
    });
  })();